import Button from 'components/Button';
import CustomTooltip from 'components/Tooltip';
import { ITextField } from 'interfaces/components/textField';

const TextField = ({
  name,
  value,
  onChange,
  icon,
  buttonLabel,
  onClick,
  placeholder,
  disableInput,
  disabled,
  color,
  buttonIcon,
  id,
  tooltip,
  readOnly,
  className = '',
  inputClassName = ''
}: ITextField) => {
  return (
    <div
      className={`border border-gray-400 dark:border-gray-700 border-solid h-12 pl-5 pr-1 py-1 rounded-full flex items-center !bg-[${color}] ${className}`}
      style={{ background: color }}
    >
      <div className='flex items-center w-full'>
        {icon && <img src={icon} alt='' />}
        <input
          className={`focus:outline-none ml-2 mr-1 placeholder:text-gray-500 dark:placeholder:text-white !bg-[${color}] leading-[19.2px] text-[18px] placeholder:text-lg focus:text-lg disabled:cursor-not-allowed disabled:opacity-50 ${inputClassName}`}
          type='text'
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disableInput}
          style={{ background: color }}
          readOnly={readOnly}
        />
        {!!tooltip?.id && !value && <CustomTooltip {...tooltip} />}
      </div>
      {buttonLabel ? (
        <Button
          id={id}
          className='px-4 text-lg h-10 bg-green-500 rounded-[200px] disabled:bg-gray-500 disabled:cursor-not-allowed disabled:text-white hover:bg-[#62c77d] transition-all duration-300'
          label={buttonLabel}
          onClick={onClick}
          disabled={disabled}
        />
      ) : (
        <img src={buttonIcon} alt='' />
      )}
    </div>
  );
};

export default TextField;
